export enum ForwardBtnTitleEnum {
	TITLE_1 = "Odeslat",
	TITLE_2 = "Přihlásit se",
	TITLE_3 = "Pokračovat",
	TITLE_4 = "Pokračovat",
	TITLE_5 = "Vybrat a pokračovat",
	TITLE_6 = "Změnit heslo",
	TITLE_7 = "Přihlásit se",
}

export enum BackwardBtnTitleEnum {
	TITLE_1 = "Udelej ze me sipku zpet pls :)",
}

export enum SendEmailAgainEnum {
	TITLE_1 = "Poslat email znovu",
}
